<template>
  <div>
    <PageAllow controller="StockOuts" action="waitOutMaterialAnalyses" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量打印 -->
              <v-menu
                v-if="
                  $permission.permissionAllow(
                    'StockOuts',
                    'waitOutMaterialAnalyses'
                  )
                "
                v-model="printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("Print.batchPrint") }}
                    <v-icon x-small class="ps-1">
                      {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 按门店批量打印 -->
                  <v-list-item @click.stop="doPrint('shop')">
                    <v-list-item-title>
                      {{ $t("waitOutMaterialAnalyses.shopPrint") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 按商品批量打印 -->
                  <v-list-item @click.stop="doPrint('material')">
                    <v-list-item-title>
                      {{ $t("waitOutMaterialAnalyses.materialPrint") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 批量导出 -->
              <v-menu
                v-if="
                  $permission.permissionAllow(
                    'StockOuts',
                    'waitOutMaterialAnalyseGroupShopExport'
                  ) ||
                  $permission.permissionAllow(
                    'StockOuts',
                    'waitOutMaterialAnalyseGroupMaterialExport'
                  )
                "
                v-model="exportBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1 float-end"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("Export.batchExport") }}
                    <v-icon x-small class="ps-1">
                      {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 按门店批量导出 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'waitOutMaterialAnalyseGroupShopExport'
                      )
                    "
                    @click.stop="exportShopExcel()"
                  >
                    <v-list-item-title>
                      {{ $t("waitOutMaterialAnalyses.shopExport") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 按商品批量导出 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'StockOuts',
                        'waitOutMaterialAnalyseGroupMaterialExport'
                      )
                    "
                    @click.stop="exportMaterialExcel()"
                  >
                    <v-list-item-title>
                      {{ $t("waitOutMaterialAnalyses.materialExport") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStock v-model="stocksSelected" />
                </v-col>
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4" v-if="stockOutTypeSelected == 1">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 客户分组 -->
                <v-col cols="12" sm="6" md="4" v-if="stockOutTypeSelected == 1">
                  <SearcherDistrictsWithDescendants
                    v-model="districtsSelected"
                    :label="$t('Shop.shopDistrict', [$consts.shopName()])"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="stockOutTypeSelected"
                    clearable
                    :items="$consts.stock_out_order.types"
                    :label="$t('StockOrderOUT.Fields.stock_out_type')"
                  >
                  </v-select>
                </v-col>
                <!-- 配送路线 -->
                <v-col cols="12" sm="6" md="4" v-if="stockOutTypeSelected == 1">
                  <SearcherDistributionUser
                    v-model="distributionUserSelected"
                    :stockId="stocksSelected ? stocksSelected.id : 0"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div
                    class="caption grey--text input-chip-group-label mb-1"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("StockOrderOUT.status.title") }}
                  </div>
                  <v-chip
                    v-model="options.mode"
                    small
                    label
                    filter
                    disabled
                    class="me-1"
                    :color="$consts.stock_out_order.status[1].color"
                    :text-color="$consts.stock_out_order.status[1].textColor"
                    :key="$consts.stock_out_order.status[1].value"
                    :value="$consts.stock_out_order.status[1].value"
                    >{{ $consts.stock_out_order.status[1].text }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_order_details"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.material_code="{ item }">
             {{ item.material_code }}
            </template>
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                {{ item.material_name }}
                <br />
                <span v-if="item.standard_name" class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
              </span>
            </template>
            <!-- 总计核定出库量(基准单位统计) -->
            <template v-slot:item.default_confirm_num="{ item }">
              {{ item.default_confirm_num | formatTwoDot
              }}{{ item.default_unit }}
            </template>
            <!-- 下单客户数 -->
            <template v-slot:item.shop_count="{ item }">
              <a
                @click="
                  currentItem = item;
                  shopDialog = true;
                "
              >
                {{ item.shop_count }}
              </a>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <v-dialog v-model="shopDialog" max-width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("waitOutMaterialAnalyses.Fields.shops") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="shopDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <v-data-table
            :headers="shopDetailsHeaders"
            :items="currentItem.shop_details"
            multi-sort
            hide-default-footer
          >
            <template v-slot:item.shop_name="{ item }">
              <span class="text-no-wrap">
                {{ "【" + item.shop_code + "】" + item.shop_name }}
              </span>
            </template>
            <template v-slot:item.default_confirm_num="{ item }">
              {{ item.default_confirm_num | formatTwoDot
              }}{{ item.default_unit }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="shopDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import StockOuts from "@/api/stock_outs";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  stock_ids: null,
  category_codes: [],
  material_ids: [],
  type: 1,
  shop_ids: [],
  district_ids: [],
  mode: 2,
  status: 2,
  distribution_user_id: null,
};

export default {
  data: () => ({
    stocksSelected: null,
    materialCategoriesSelected: [],
    materialSelected: null,
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("waitOut-material-analyses-options")
        ? sessionStorage.getItem("waitOut-material-analyses-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    districtsSelected: [],
    shopsSelected: [],
    stock_order_details: [],
    currentItem: {},
    shopDialog: false,
    stockOutTypeSelected: sessionStorage.getItem(
      "waitOut-material-analyses-stockOutTypeSelected"
    )
      ? JSON.parse(
          sessionStorage.getItem(
            "waitOut-material-analyses-stockOutTypeSelected"
          )
        )
      : 1,
    distributionUserSelected: null,
    exportBtnMenu: false,
    printBtnMenu: false,
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterialCategoriesWithDescendants,
    SearcherMaterials,
    SearcherStock,
    SearcherShops,
    SearcherDistrictsWithDescendants,
    SearcherDistributionUser,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.waitOutMaterialAnalyses"),
        disabled: true,
        href: "/wait-out-material-analyses",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("stockOrderAnalyze.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("stockOrderAnalyze.Fields.actual_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("waitOutMaterialAnalyses.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("waitOutMaterialAnalyses.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("waitOutMaterialAnalyses.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        //总计核定出库量(基准单位统计)
        {
          text: i18n.t("waitOutMaterialAnalyses.Fields.default_confirm_num"),
          align: "start",
          sortable: false,
          value: "default_confirm_num",
        },
      ];
      //总计计数单位出库量(基准单位)
      if (this.settings && this.settings.count_unit == 1) {
        headers.push({
          text: i18n.t("waitOutMaterialAnalyses.Fields.count_unit_num"),
          align: "start",
          sortable: false,
          value: "count_unit_num",
        });
      }

      //下单客户数
      if (this.stockOutTypeSelected == 1) {
        headers.push({
          text: i18n.t("waitOutMaterialAnalyses.Fields.shop_count"),
          align: "start",
          sortable: false,
          value: "shop_count",
        });
      }
      return headers;
    },
    shopDetailsHeaders: () => [
      {
        text: i18n.t("waitOutMaterialAnalyses.Fields.shop_name"),
        align: "start",
        sortable: false,
        value: "shop_name",
      },
      {
        text: i18n.t("waitOutMaterialAnalyses.Fields.stock_order_code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("waitOutMaterialAnalyses.Fields.shop_default_confirm_num"),
        align: "start",
        sortable: false,
        value: "default_confirm_num",
      },
    ],
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("waitOut-material-analyses", [
        "stocksSelected",
        "shopsSelected",
        "districtsSelected",
        "materialCategoriesSelected",
        "materialSelected",
        "stockOutTypeSelected",
        "distributionUserSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "districtsSelected":
                this.districtsSelected = selected.value;
                break;
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "stockOutTypeSelected":
                this.stockOutTypeSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stocksSelected = null;
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.stockOutTypeSelected = 1;
      this.districtsSelected = [];
      this.shopsSelected = [];
      this.distributionUserSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getWaitOutMaterialAnalysesFromAPI() {
      this.loading = true;
      StockOuts.waitOutMaterialAnalyses(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_order_details = response.data.stock_order_details;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportShopExcel() {
      StockOuts.shopExport(this.options);
    },
    exportMaterialExcel() {
      StockOuts.materialExport(this.options);
    },
    doPrint(type) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          options.fromType = type;
          if (type == "material") {
            options.mode = 2;
          } else {
            options.mode = 3;
          }
          var path = null;
          path = "print/wait-out-material-analyse-print";
          if (path) this.$router.push({ path: path, query: options });
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getWaitOutMaterialAnalysesFromAPI();
        sessionStorage.setItem(
          "waitOut-material-analyses-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : null;
        sessionStorage.setItem(
          "waitOut-material-analyses-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : "";
        sessionStorage.setItem(
          "waitOut-material-analyses-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "waitOut-material-analyses-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 客户选择
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((alliance) => {
              return alliance.id;
            })
          : "";
        sessionStorage.setItem(
          "waitOut-material-analyses-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    // 分组查询
    districtsSelected: {
      handler() {
        this.options.district_ids = this.districtsSelected
          ? this.districtsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "waitOut-material-analyses-districtsSelected",
          JSON.stringify(this.districtsSelected)
        );
      },
    },
    stockOutTypeSelected: {
      immediate: true,
      handler() {
        if (this.stockOutTypeSelected != 1) {
          this.districtsSelected = [];
          this.shopsSelected = [];
          this.distributionUserSelected = null;
        }
        this.options.type = this.stockOutTypeSelected
          ? this.stockOutTypeSelected
          : "";
        sessionStorage.setItem(
          "waitOut-material-analyses-stockOutTypeSelected",
          JSON.stringify(this.stockOutTypeSelected)
        );
      },
    },
    distributionUserSelected: {
      handler() {
        this.options.distribution_user_id = this.distributionUserSelected
          ? this.distributionUserSelected.id
          : null;
        sessionStorage.setItem(
          "waitOut-material-analyses-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
  },
};
</script>